module.exports = __webpack_public_path__ + "static/media/oz.6c706424.png";